<template>
  <layout>
    <template slot="header">
      Filter
    </template>
    <template>
      <div class="mx-4" v-if="localList.length">
        <template v-for="(item, index) in localList">
          <v-select
            v-if="!item.type"
            :menu-props="{ closeOnContentClick: true, bottom: true, offsetY: true  }"
            :key="item.id"
            :data-test-filter="item.id"
            v-model="item.model"
            :label="item.title"
            item-text="name"
            :items="item.values"
            class="mx-0 my-4"
            hide-no-data
            :disabled="item.disabled"
            return-object
          >
            <template v-slot:item="{ item }">
              <div :data-test-filter-value="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>

          <v-autocomplete
            :menu-props="{ closeOnContentClick: true }"
            :data-test-filter="item.id"
            hide-selected
            hide-no-data
            :key="item.id"
            v-else-if="item.type && item.type === 'tags'"
            :disabled="item.disabled"
            :label="item.title"
            v-model="item.model"
            :items="item.values"
            chips
            multiple
            item-text="name"
            return-object
          >
            <template v-slot:item="{ item }">
              <div :data-test-filter-value="item.name">
                {{ item.name }}
              </div>
            </template>
            <template v-slot:selection="data">
              <v-chip
                small
                color="primary"
                close
                @click:close="handleClose(data.item, index)"
                close-icon="mdi-close-circle"
              >
                {{ data.item.name }}
              </v-chip>
            </template>
          </v-autocomplete>
          <v-combobox
            :data-test-filter="item.id"
            :menu-props="{ closeOnContentClick: true }"
            hide-selected
            hide-no-data
            :key="item.id"
            v-else-if="item.type && item.type === 'tags-live'"
            :disabled="item.disabled"
            :label="item.title"
            v-model="item.model"
            :items="item.values"
            chips
            multiple
            item-text="name"
          >
            <template v-slot:item="{ item }">
              <div :data-test-filter-value="item">
                {{ item }}
              </div>
            </template>
            <template v-slot:selection="data">
              <v-chip
                small
                color="primary"
                close
                @click:close="handleClose(data.item, index)"
                close-icon="mdi-close-circle"
              >
                {{ data.item }}
              </v-chip>
            </template>
          </v-combobox>
          <!--          <history-datepicker-field-->
          <!--            :key="item.id"-->
          <!--            v-else-if="item.type && item.type === 'date::from'"-->
          <!--            :label="item.title"-->
          <!--            v-model="item.model"-->
          <!--            is-start-->
          <!--          />-->
          <!--          <history-datepicker-field-->
          <!--            :key="item.id"-->
          <!--            v-else-if="item.type && item.type === 'date::to'"-->
          <!--            :label="item.title"-->
          <!--            v-model="item.model"-->
          <!--          />-->

          <v-menu
            v-model="isOpenDateFrom"
            :key="item.id"
            :close-on-content-click="false"
            v-else-if="item.type && item.type === 'date::from'"
            transition="scale-transition"
            max-width="290px"
            min-width="auto"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="item.model"
                :label="item.title"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :data-test-filter="item.id"
              v-model="item.model"
              @input="isOpenDateFrom = false"
            >
            </v-date-picker>
          </v-menu>
          <v-menu
            v-model="isOpenDateTo"
            :key="item.id"
            :close-on-content-click="false"
            v-else-if="item.type && item.type === 'date::to'"
            transition="scale-transition"
            max-width="290px"
            min-width="auto"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="item.model"
                :label="item.title"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :data-test-filter="item.id"
              v-model="item.model"
              @input="isOpenDateTo = false"
            >
            </v-date-picker>
          </v-menu>
          <!--          <v-date-picker-->
          <!--            v-model="item.model"-->
          <!--            range-->
          <!--            v-else-if="item.type && item.type === 'date::from'"-->
          <!--            :key="item.id"-->
          <!--          >-->
          <!--          </v-date-picker>-->
        </template>
        <v-btn
          data-test-filter-clear="clearAll"
          outlined
          color="primary"
          class="mb-4"
          block
          @click.stop="resetFilterHandler"
        >
          clear all
        </v-btn>
      </div>
      <div class="wrapper ma-6 d-flex align-center justify-center" v-else>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </template>
    <template slot="footer">
      <v-spacer />
      <v-btn text @click.stop="close" data-test-filter-apply="cancel">
        cancel
      </v-btn>
      <v-btn
        data-test-filter-apply="apply"
        color="primary"
        text
        :disabled="localList.length <= 0"
        @click.stop="apply"
      >
        apply
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import { onMounted, ref, onUnmounted, watch } from '@vue/composition-api';
// import HistoryDatepickerField from '@/components/history-card/HistoryDatepickerField';

import cloneDeep from 'lodash.clonedeep';
import isEqual from 'lodash.isequal';
import { EventBus } from '@/utils/eventBus';
export default {
  name: 'tableFilter',
  props: ['filters', 'emptyFilters', 'showPopup'],
  components: {
    Layout
    // HistoryDatepickerField
  },
  setup(props, { emit }) {
    const localList = ref([]);
    const resetFilter = ref([]);
    const isOpenDateFrom = ref(false);
    const isOpenDateTo = ref(false);

    function apply() {
      emit('save', localList.value);
      close();
      EventBus.$emit('reset-pagination');
    }

    function handleClose(data, index) {
      const indexDeleting = localList.value[index].model.findIndex(
        item => item === data
      );
      localList.value[index].model.splice(indexDeleting, 1);
    }

    function close() {
      emit('show-changed', isEqual(props.filters, localList.value));
      emit('close');
    }

    function resetFilterHandler() {
      localList.value = cloneDeep(props.emptyFilters);
    }

    watch(
      () => props.showPopup,
      value => {
        if (value) {
          localList.value = props.filters;
        }
      },
      {
        immediate: true,
        deep: true
      }
    );

    onUnmounted(() => {
      emit('save', []);
    });

    return {
      localList,
      resetFilter,
      handleClose,
      apply,
      close,
      resetFilterHandler,
      isOpenDateFrom,
      isOpenDateTo
    };
  }
};
</script>
